"use client"

import { useEffect, useState, useContext } from "react";
import client from "../../api/client";
import CourseCard from "../Category/CourseCard2";
import { GlobalContext } from "../../context/index";
import Animator from "../../components/Aminator/Animator";

export default function CorporateCourses() {
     const {
      userLocation,
      } = useContext(GlobalContext)

    const [, setLoading] = useState(true);
    const [course, setCourse] = useState([]);
    const loadData = async (id) => {
        setLoading(true);
        try {
            const res = (await client.get(`/v2/courses?category=${34}`)).data;
          setCourse(res.data || []);
        //   setFilteredCourses(res.data);
        } catch (error) {
          console.log("error fetching data", error.response);
        }
        setLoading(false);
      };
    
      useEffect(() => {
        loadData(34);
      }, []);
        

    return (
        <section className="py-[58px] bg-white overflow-hidden">
            <div className=" px-6 md:px-20">
                {/* Header */}
                <Animator variant="slide" direction="right" timeout={800} delay={300} >              
                <div className="text-left mb-12">
                    <h2 className="text-3xl md:text-4xl font-semibold  mb-3">Our Top Corporate Courses</h2>
                    <p className="text-[#7F7F7F] text-lg max-w-3xl leading-relaxed">
                        Each course is hands-on, practical, and designed to reduce errors by 30%, improve task turnaround by 40%.
                    </p>
                </div>
                </Animator>

                {/* Courses Grid */}
                {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {course.map((course) => (
                        <div
                            key={course.id}
                            className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 group hover:-translate-y-2"
                        >
                            
                            <div className="relative overflow-hidden">
                                <img
                                    src={course.image_url || "/placeholder.svg"}
                                    alt={course.title}
                                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                                />
                            </div>

                            <div className="p-[18px]">
                               
                                <div className="flex items-center justify-between mb-2">
                                    <div className="">
                                        <span className="bg-[#FFF0F0] text-[#882929] text-[10px] font-semibold px-[6px] py-1 rounded-full">
                                            {course.category}
                                        </span>
                                    </div>

                                    
                                    <div className="">
                                        <span className="bg-white/95 backdrop-blur-sm text-[#FF6636] font-medium text-lg px-3 py-1 rounded-full">
                                            {course.price}
                                        </span>
                                    </div>
                                </div>
                               
                                <h3 className="text-base font-medium text-[#1D2026] mb-[14px] line-clamp-2 transition-colors">
                                    {course.title}
                                </h3>

                               
                                <hr/>
                                
                                <div className="flex items-center justify-between my-[14px]">
                                    <div className="flex items-center gap-1">
                                        <Star className="w-4 h-4 fill-[#FD8E1F] text-[#FD8E1F]" />
                                        <span className="text-sm font-medium text-[#4E5566]">{course.reviews_info}</span> 
                                    </div>

                                    <div className="flex items-center gap-1 text-[#8C94A3]">
                                        <Clock className="w-4 h-4" />
                                        <span className="text-xs">{course.duration}</span>
                                    </div>
                                </div>

                               
                                <button className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200">
                                    Enroll Now
                                </button>
                            </div>
                        </div>
                    ))}
                </div> */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {course.map((cou) => (
                        < CourseCard
                          course={cou}
                              price={
                                userLocation?.data === "NG"
                                  ? `₦${Number(cou.price_ngn).toLocaleString()}`
                                  : `$${Number(cou.price_usd).toLocaleString()}`
                              }
                        />
                    ))}
                </div>

                {/* View All Courses Button */}
                {/* <div className="text-center mt-12">
                    <button className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-3 px-8 rounded-lg transition-colors duration-200">
                        View All Courses
                    </button>
                </div> */}
            </div>
        </section>
    )
}
